const getDefaultState = () => {
    return {
        // 标签页列表
        editableTabs: [
            // 默认首页标签，路径应与路由保持一致
            { title: '首页', name: '/home-page', closable: false } 
        ],
        // 当前激活的标签页的 name (即路由 path)
        editableTabsValue: '/home-page', 
    }
}

const state = getDefaultState()

const mutations = {
    // 1. 设置当前激活的标签
    SET_ACTIVE_TAB(state, path) {
        state.editableTabsValue = path;
    },

    // 2. 添加一个新的标签页
    ADD_TAB(state, { title, path }) {
        const existingTab = state.editableTabs.find(tab => tab.name === path);
        if (!existingTab) {
            state.editableTabs.push({
                title: title,
                name: path,
                closable: path !== '/home-page' // 首页不可关闭
            });
        }
        state.editableTabsValue = path;
    },

    // 3. 移除一个标签页
    REMOVE_TAB(state, targetName) {
        const tabs = state.editableTabs;
        let activeName = state.editableTabsValue;
        
        // 如果关闭的是当前激活的标签
        if (activeName === targetName) {
            tabs.forEach((tab, index) => {
                if (tab.name === targetName) {
                    // 激活前一个或后一个标签
                    const nextTab = tabs[index + 1] || tabs[index - 1];
                    if (nextTab) {
                        activeName = nextTab.name;
                    }
                }
            });
        }

        state.editableTabsValue = activeName;
        state.editableTabs = tabs.filter(tab => tab.name !== targetName);
    }
}

export default {
    namespaced: true, // 启用命名空间
    state,
    mutations
}